function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _assert_this_initialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _get_prototype_of(o) {
    _get_prototype_of = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _get_prototype_of(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _set_prototype_of(subClass, superClass);
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _possible_constructor_return(self, call) {
    if (call && (_type_of(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assert_this_initialized(self);
}
function _set_prototype_of(o, p) {
    _set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _set_prototype_of(o, p);
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _is_native_reflect_construct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e1) {
        return false;
    }
}
function _create_super(Derived) {
    var hasNativeReflectConstruct = _is_native_reflect_construct();
    return function _createSuperInternal() {
        var Super = _get_prototype_of(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _get_prototype_of(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possible_constructor_return(this, result);
    };
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e1) {
            op = [
                6,
                e1
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var _this = this;
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { editBillingDetails, getFullUserDetails } from "@common/actions/user-details";
import RichText from "@common/components/BoxDetailsTab/RichText";
import { hashCode } from "@common/utils/helpers";
import PrismicClient from "@common/utils/prismic";
import { SNACKBAR_AUTOHIDE_TIMEOUT, SNACKBAR_VARIANT_ERROR } from "@config/constants";
import { withSnackbar } from "notistack";
import React, { PureComponent, useRef, useState, useEffect } from "react";
import { connect } from "react-redux";
import { SIGN_IN_DEFAULT_REDIRECT } from "@config/constants";
import { withRouter } from "react-router-dom";
import { Redirect } from "react-router-dom";
import { Accordion, AccordionDetails, AccordionSummary, Button, Drawer, Typography } from "@material-ui/core";
import { closeModal } from "@common/actions";
import GuideSideMenu from "@common/components/GuideSideMenu";
import { styled } from "@material-ui/styles";
import { isEmpty } from "lodash";
function renderSectionText(text, stepsRef) {
    var elements = [];
    var lastItemType = null;
    var listChildren = [];
    var listItemKey = null;
    var stepIdx = 0;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = text.entries()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = _sliced_to_array(_step.value, 2), i = _step_value[0], item = _step_value[1];
            var _item_text;
            var childKey = "".concat(i, "_").concat(hashCode((_item_text = item.text) !== null && _item_text !== void 0 ? _item_text : item.id));
            if (lastItemType !== item.type) {
                if (lastItemType === "o-list-item" || lastItemType === "list-item" && listChildren.length) {
                    elements.push(lastItemType === "o-list-item" ? /*#__PURE__*/ _jsx("ol", {
                        children: listChildren
                    }, listItemKey) : /*#__PURE__*/ _jsx("ul", {
                        children: listChildren
                    }, listItemKey));
                }
                listItemKey = null;
                listChildren = [];
            }
            lastItemType = item.type;
            switch(item.type){
                case "image":
                case "paragraph":
                    elements.push(/*#__PURE__*/ _jsx(RichText, _object_spread({}, item), childKey));
                    break;
                case "o-list-item":
                case "list-item":
                    if (!listItemKey) {
                        listItemKey = childKey;
                    }
                    listChildren.push(/*#__PURE__*/ _jsx("li", {
                        children: /*#__PURE__*/ _jsx(RichText, _object_spread({
                            style: {
                                display: "inline"
                            }
                        }, item))
                    }, "li_".concat(childKey)));
                    break;
                case "heading2":
                    elements.push(/*#__PURE__*/ _jsx(RichText, _object_spread({
                        ref: function(el) {
                            stepsRef.current[stepIdx] = el;
                        },
                        id: "step".concat(stepIdx)
                    }, item), childKey));
                    stepIdx++;
                    break;
                default:
                    elements.push(/*#__PURE__*/ _jsx(RichText, _object_spread({}, item), childKey));
                    break;
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    if (listChildren.length) {
        elements.push(lastItemType === "o-list-item" ? /*#__PURE__*/ _jsx("ol", {
            children: listChildren
        }, listItemKey) : /*#__PURE__*/ _jsx("ul", {
            children: listChildren
        }, listItemKey));
        listItemKey = null;
        listChildren = [];
    }
    return /*#__PURE__*/ _jsxs("div", {
        children: _to_consumable_array(elements)
    });
}
var GuideSteps = function(props) {
    var sectionData = props.sectionData, subroute = props.subroute;
    var sidebarStepsRef = useRef([]);
    var stepsRef = useRef([]);
    var sectionContentRef = useRef(null);
    var observerRef = useRef(null);
    var manualSelectionRef = useRef({
        active: false,
        index: null,
        timestamp: 0
    });
    var _useState = _sliced_to_array(useState(0), 2), activeIdx = _useState[0], setActiveIdx = _useState[1];
    var _useState1 = _sliced_to_array(useState({}), 2), fullData = _useState1[0], setFullData = _useState1[1];
    useEffect(function() {
        var _this1 = _this;
        var fetchData = function() {
            var _ref = _async_to_generator(function() {
                var prismicData, fullData, e1, _this_props_i18n_errors_prismic, localizedErrorMessage;
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            if (!PrismicClient.hasPrismic()) return [
                                2
                            ];
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                3,
                                ,
                                4
                            ]);
                            return [
                                4,
                                PrismicClient.getAppGuide()
                            ];
                        case 2:
                            prismicData = _state.sent();
                            fullData = prismicData[0].body.find(function(category) {
                                return category.items.find(function(i) {
                                    return i.section_url === subroute;
                                });
                            });
                            setFullData(fullData.items.find(function(i) {
                                return i.section_url === subroute;
                            }));
                            setActiveIdx(0);
                            // Reset manual selection when data changes
                            manualSelectionRef.current = {
                                active: false,
                                index: null,
                                timestamp: 0
                            };
                            return [
                                3,
                                4
                            ];
                        case 3:
                            e1 = _state.sent();
                            localizedErrorMessage = ((_this_props_i18n_errors_prismic = _this1.props.i18n.errors.prismic) === null || _this_props_i18n_errors_prismic === void 0 ? void 0 : _this_props_i18n_errors_prismic[e.message]) || _this1.props.i18n.errors.generic;
                            _this1.props.enqueueSnackbar(localizedErrorMessage, {
                                variant: SNACKBAR_VARIANT_ERROR,
                                autoHideDuration: SNACKBAR_AUTOHIDE_TIMEOUT
                            });
                            return [
                                3,
                                4
                            ];
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            });
            return function fetchData() {
                return _ref.apply(this, arguments);
            };
        }();
        if (!sectionData) {
            fetchData();
        } else {
            setFullData(sectionData);
            setActiveIdx(0);
            // Reset manual selection when data changes
            manualSelectionRef.current = {
                active: false,
                index: null,
                timestamp: 0
            };
        }
    }, [
        sectionData,
        subroute
    ]);
    // Use IntersectionObserver to track which h2 elements are visible
    useEffect(function() {
        if (isEmpty(fullData)) return;
        // Wait a bit for the DOM to render
        var setupObserver = function() {
            var h2Elements = [];
            // Get all step elements using the actual number of steps
            var steps = (fullData === null || fullData === void 0 ? void 0 : fullData.guide_text.filter(function(e1) {
                return e1.type === "heading2";
            })) || [];
            for(var i = 0; i < steps.length; i++){
                var stepEl = document.getElementById("step".concat(i));
                if (stepEl) {
                    h2Elements.push({
                        index: i,
                        element: stepEl
                    });
                }
            }
            if (h2Elements.length === 0) {
                return;
            }
            // Cleanup previous observer if exists
            if (observerRef.current) {
                observerRef.current.disconnect();
            }
            // Keep track of which elements are in view
            var visibleElements = new Set();
            // Create a bottom detector element to know when we've reached the end
            var bottomDetectorId = "bottom-detector";
            var bottomDetector = document.getElementById(bottomDetectorId);
            // If there's no bottom detector yet, create one
            if (!bottomDetector) {
                bottomDetector = document.createElement("div");
                bottomDetector.id = bottomDetectorId;
                bottomDetector.style.width = "100%";
                bottomDetector.style.height = "1px";
                bottomDetector.style.position = "relative";
                bottomDetector.style.marginTop = "-1px"; // Place it just above the end
                // Find the section-steps element and append the detector to it
                var sectionSteps = document.querySelector(".section-steps");
                if (sectionSteps) {
                    sectionSteps.appendChild(bottomDetector);
                }
            }
            // Flag to track if we've reached the bottom
            var isAtBottom = false;
            // Create separate observer for bottom detection
            var bottomObserver = new IntersectionObserver(function(entries) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = entries[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var entry = _step.value;
                        isAtBottom = entry.isIntersecting;
                        // If a step was manually selected recently (within 1 second), don't update
                        var now = Date.now();
                        if (manualSelectionRef.current.active && now - manualSelectionRef.current.timestamp < 1000) {
                            return;
                        }
                        // If we're at the bottom, activate the last step
                        if (isAtBottom && h2Elements.length > 0) {
                            var lastIndex = h2Elements[h2Elements.length - 1].index;
                            setActiveIdx(lastIndex);
                            // Reset manual selection after auto-updating
                            manualSelectionRef.current.active = false;
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }, {
                root: null,
                rootMargin: "0px 0px 50px 0px",
                threshold: 0.1
            });
            // Observe the bottom detector
            if (bottomDetector) {
                bottomObserver.observe(bottomDetector);
            }
            // Create observer for headings
            observerRef.current = new IntersectionObserver(function(entries) {
                // If a step was manually selected recently (within 1 second), don't update
                var now = Date.now();
                if (manualSelectionRef.current.active && now - manualSelectionRef.current.timestamp < 1000) {
                    return;
                }
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = entries[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var entry = _step.value;
                        // Extract the index from the element id (e.g., "step0" -> 0)
                        var index = Number.parseInt(entry.target.id.replace("step", ""), 10);
                        if (entry.isIntersecting) {
                            visibleElements.add(index);
                        } else {
                            visibleElements.delete(index);
                        }
                        // If we're at the bottom, prioritize the last element
                        if (isAtBottom && h2Elements.length > 0) {
                            var lastIndex = h2Elements[h2Elements.length - 1].index;
                            setActiveIdx(lastIndex);
                            // Reset manual selection after auto-updating
                            manualSelectionRef.current.active = false;
                        } else if (visibleElements.size > 0) {
                            var _Math;
                            var newActiveIdx = (_Math = Math).min.apply(_Math, _to_consumable_array(visibleElements));
                            setActiveIdx(newActiveIdx);
                            // Reset manual selection after auto-updating
                            manualSelectionRef.current.active = false;
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }, {
                // Use viewport as root (null)
                root: null,
                // Add margin to trigger slightly before elements enter the viewport
                rootMargin: "0px 0px -20% 0px",
                threshold: 0.1
            });
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                // Observe all h2 elements
                for(var _iterator = h2Elements[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var element = _step.value.element;
                    observerRef.current.observe(element);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            // Return both observers for cleanup
            return {
                headingObserver: observerRef.current,
                bottomObserver: bottomObserver
            };
        };
        // Give the DOM time to render before setting up the observer
        var timerId = setTimeout(function() {
            var observers = setupObserver();
            if (observers) {
                observerRef.current = observers.headingObserver;
            // Store bottom observer in a ref if needed for cleanup
            }
        }, 1000);
        return function() {
            clearTimeout(timerId);
            // Clean up highlights using the correct number of steps
            var steps = (fullData === null || fullData === void 0 ? void 0 : fullData.guide_text.filter(function(e1) {
                return e1.type === "heading2";
            })) || [];
            for(var i = 0; i < steps.length; i++){
                var stepEl = document.getElementById("step".concat(i));
                if (stepEl) {
                    stepEl.classList.remove("intersection-highlight");
                }
            }
            // Remove bottom detector
            var bottomDetector = document.getElementById("bottom-detector");
            if (bottomDetector) {
                bottomDetector.remove();
            }
            if (observerRef.current) {
                observerRef.current.disconnect();
                observerRef.current = null;
            }
        };
    }, [
        fullData
    ]);
    // Function to handle scrolling to a step with optimal positioning
    var scrollToStep = function(index) {
        // Set the active index first (UI feedback)
        setActiveIdx(index);
        // Mark as manually selected with timestamp
        manualSelectionRef.current = {
            active: true,
            index: index,
            timestamp: Date.now()
        };
        // Get the target element
        var targetEl = document.getElementById("step".concat(index));
        if (!targetEl) return;
        var header = document.querySelector(".modal-header");
        if (header.checkVisibility()) {
            var headerOffset = header.getBoundingClientRect().height;
            var routerContainer = document.querySelector(".router-container");
            routerContainer.scrollTo({
                top: targetEl.getBoundingClientRect().top + routerContainer.scrollTop - (routerContainer.getBoundingClientRect().y + headerOffset)
            });
        } else targetEl.scrollIntoView({
            behavior: "instant",
            block: "start"
        });
    };
    if (isEmpty(fullData)) return /*#__PURE__*/ _jsx(_Fragment, {});
    var steps = fullData === null || fullData === void 0 ? void 0 : fullData.guide_text.filter(function(e1) {
        return e1.type === "heading2";
    });
    return /*#__PURE__*/ _jsxs("div", {
        className: "section-content-wrapper",
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "section-content",
                ref: sectionContentRef,
                children: [
                    /*#__PURE__*/ _jsx("h1", {
                        className: "steps-section-title",
                        children: fullData.section_title
                    }),
                    /*#__PURE__*/ _jsx(StepsMenu, {
                        steps: steps,
                        activeIdx: activeIdx,
                        scrollToStep: scrollToStep,
                        className: "section-sidebar"
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "section-steps",
                        children: renderSectionText(fullData.guide_text, stepsRef)
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(StepsMenu, {
                steps: steps,
                activeIdx: activeIdx,
                scrollToStep: scrollToStep,
                className: "section-sidebar-outer"
            })
        ]
    });
};
var StepsMenu = function(props) {
    var steps = props.steps, activeIdx = props.activeIdx, scrollToStep = props.scrollToStep, className = props.className;
    return /*#__PURE__*/ _jsx("div", {
        className: "section-sidebar-base ".concat(className),
        id: className === "section-sidebar" ? "section-sidebar" : null,
        children: steps === null || steps === void 0 ? void 0 : steps.map(function(item, i) {
            var isActive = i === activeIdx;
            return /*#__PURE__*/ _jsx(Button, {
                className: "sidebar-step".concat(isActive ? "-active" : ""),
                style: {
                    justifyContent: "start",
                    textTransform: "initial",
                    fontSize: 16
                },
                onClick: function() {
                    return scrollToStep(i);
                },
                children: item.text
            }, item.text);
        })
    });
};
var GuidePage = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    _inherits(GuidePage, PureComponent);
    var _super = _create_super(GuidePage);
    function GuidePage(props) {
        _class_call_check(this, GuidePage);
        var _this;
        _this = _super.call(this, props);
        _this.state = {
            prismicData: null,
            menuOpen: false,
            sectionData: null,
            subroute: null
        };
        _this.setSectionData = _this.setSectionData.bind(_assert_this_initialized(_this));
        _this.closeMenu = _this.closeMenu.bind(_assert_this_initialized(_this));
        _this.setSubroute = _this.setSubroute.bind(_assert_this_initialized(_this));
        _this.getSectionTitle = _this.getSectionTitle.bind(_assert_this_initialized(_this));
        return _this;
    }
    _create_class(GuidePage, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var _this = this;
                return _async_to_generator(function() {
                    var token, data, prismicData, e1, _this_props_i18n_errors_prismic, localizedErrorMessage;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (_this.props.subroute) {
                                    _this.setState({
                                        subroute: _this.props.subroute
                                    });
                                }
                                token = _this.props.authentication.token;
                                data = {
                                    token: token,
                                    cf_guide: ""
                                };
                                if (!PrismicClient.hasPrismic()) return [
                                    2
                                ];
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4,
                                    PrismicClient.getAppGuide()
                                ];
                            case 2:
                                prismicData = _state.sent();
                                _this.setState({
                                    prismicData: prismicData[0]
                                });
                                return [
                                    3,
                                    4
                                ];
                            case 3:
                                e1 = _state.sent();
                                localizedErrorMessage = ((_this_props_i18n_errors_prismic = _this.props.i18n.errors.prismic) === null || _this_props_i18n_errors_prismic === void 0 ? void 0 : _this_props_i18n_errors_prismic[e.message]) || _this.props.i18n.errors.generic;
                                _this.props.enqueueSnackbar(localizedErrorMessage, {
                                    variant: SNACKBAR_VARIANT_ERROR,
                                    autoHideDuration: SNACKBAR_AUTOHIDE_TIMEOUT
                                });
                                return [
                                    3,
                                    4
                                ];
                            case 4:
                                try {
                                    _this.props.editBillingDetails(data).then(function() {
                                        _this.props.getFullUserDetails();
                                    });
                                } catch (error) {
                                    console.log(error);
                                }
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "closeMenu",
            value: function closeMenu() {
                this.setState({
                    menuOpen: false
                });
            }
        },
        {
            key: "setSectionData",
            value: function setSectionData(data) {
                this.setState({
                    sectionData: data
                });
            }
        },
        {
            key: "setSubroute",
            value: function setSubroute(subroute) {
                this.setState({
                    subroute: subroute
                });
            }
        },
        {
            key: "getSectionTitle",
            value: function getSectionTitle() {
                var _this = this;
                var _history_location_state;
                var _this_props = this.props, match = _this_props.match, history = _this_props.history;
                if (this.state.sectionData) {
                    return this.state.sectionData.section_title;
                }
                if ((_history_location_state = history.location.state) === null || _history_location_state === void 0 ? void 0 : _history_location_state.sectionData) {
                    return history.location.state.sectionData.section_title;
                }
                if (match.params.category === "home" || this.state.subroute === "home") {
                    return this.props.i18n.common.apps;
                }
                if (match.params.category || this.state.subroute) {
                    var _title_primary;
                    var title = this.state.prismicData.body.find(function(category) {
                        return category.items.find(function(i) {
                            return i.section_url === match.params.category || i.section_url === _this.state.subroute;
                        });
                    });
                    return title === null || title === void 0 ? void 0 : (_title_primary = title.primary) === null || _title_primary === void 0 ? void 0 : _title_primary.category_title;
                }
                return this.props.i18n.common.apps;
            }
        },
        {
            key: "render",
            value: function render() {
                var _this = this;
                var _this_state_sectionData, _this_state_sectionData1, _this_state, _history_location_state, _this_props_match_params;
                var _this_state1 = this.state, prismicData = _this_state1.prismicData, menuOpen = _this_state1.menuOpen;
                if (!prismicData) return null;
                var _this_props = this.props, history = _this_props.history, isModal = _this_props.isModal, subroute = _this_props.subroute, _$closeModal = _this_props.closeModal, authentication = _this_props.authentication;
                if (!authentication.token) {
                    var route = authentication.lastRequestedRoute || SIGN_IN_DEFAULT_REDIRECT;
                // return <Redirect to={route} />;
                }
                var isSubroute = !isEmpty(this.props.match.params);
                var _this_state_sectionData_section_url, _this_state_sectionData_section_url1, _this_props_match_params_category;
                return /*#__PURE__*/ _jsxs("div", {
                    className: "modal guide".concat(isModal ? "-small" : ""),
                    children: [
                        /*#__PURE__*/ _jsxs("div", {
                            className: "modal-header",
                            children: [
                                /*#__PURE__*/ _jsx("span", {
                                    className: "icon icon-menu-2 pointer menu-icon",
                                    onClick: function() {
                                        return _this.setState({
                                            menuOpen: !menuOpen
                                        });
                                    },
                                    onKeyDown: function() {
                                        return _this.setState({
                                            menuOpen: !menuOpen
                                        });
                                    }
                                }),
                                /*#__PURE__*/ _jsx("h1", {
                                    className: "modal-title",
                                    children: "".concat(this.getSectionTitle())
                                }),
                                /*#__PURE__*/ _jsx("span", {
                                    onClick: _$closeModal,
                                    onKeyDown: _$closeModal,
                                    className: "icon icon-clear pointer"
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsx(Drawer, {
                            open: menuOpen,
                            className: "side-menu-drawer",
                            onClose: function() {
                                return _this.closeMenu();
                            },
                            style: {
                                maxWidth: "80%"
                            },
                            children: /*#__PURE__*/ _jsx(GuideSideMenu, {
                                prismicData: prismicData,
                                activeRoute: isModal ? (_this_state_sectionData_section_url = (_this_state_sectionData = this.state.sectionData) === null || _this_state_sectionData === void 0 ? void 0 : _this_state_sectionData.section_url) !== null && _this_state_sectionData_section_url !== void 0 ? _this_state_sectionData_section_url : subroute : this.props.match.params.category,
                                history: history,
                                isModal: isModal,
                                setSectionData: this.setSectionData,
                                closeMenu: this.closeMenu,
                                setSubroute: this.setSubroute
                            })
                        }),
                        /*#__PURE__*/ _jsx(GuideSideMenu, {
                            prismicData: prismicData,
                            activeRoute: isModal ? (_this_state_sectionData_section_url1 = (_this_state_sectionData1 = this.state.sectionData) === null || _this_state_sectionData1 === void 0 ? void 0 : _this_state_sectionData1.section_url) !== null && _this_state_sectionData_section_url1 !== void 0 ? _this_state_sectionData_section_url1 : subroute : this.props.match.params.category,
                            history: history,
                            isModal: isModal,
                            setSectionData: this.setSectionData,
                            setSubroute: this.setSubroute
                        }),
                        isSubroute || isModal && (this.state.sectionData || this.state.subroute) && this.state.subroute !== "home" ? /*#__PURE__*/ _jsx(GuideSteps, {
                            sectionData: isModal ? (_this_state = this.state) === null || _this_state === void 0 ? void 0 : _this_state.sectionData : (_history_location_state = history.location.state) === null || _history_location_state === void 0 ? void 0 : _history_location_state.sectionData,
                            subroute: (_this_props_match_params_category = (_this_props_match_params = this.props.match.params) === null || _this_props_match_params === void 0 ? void 0 : _this_props_match_params.category) !== null && _this_props_match_params_category !== void 0 ? _this_props_match_params_category : this.state.subroute
                        }) : /*#__PURE__*/ _jsxs("div", {
                            className: "content-holder",
                            children: [
                                renderSectionText(prismicData.welcome_text),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "content-categories",
                                    children: prismicData.body.map(function(data) {
                                        return /*#__PURE__*/ _jsxs("div", {
                                            className: "category",
                                            children: [
                                                /*#__PURE__*/ _jsx("span", {
                                                    className: "home-title",
                                                    children: data.primary.category_title
                                                }),
                                                /*#__PURE__*/ _jsx("img", {
                                                    src: "".concat(data.primary.category_image.url),
                                                    alt: "".concat(data.primary.category_image.alt),
                                                    className: "category-image"
                                                }),
                                                data.items.map(function(item) {
                                                    return /*#__PURE__*/ _jsx(Button, {
                                                        style: {
                                                            textTransform: "none"
                                                        },
                                                        onClick: function() {
                                                            if (isModal) {
                                                                _this.setState({
                                                                    sectionData: item
                                                                });
                                                                _this.setSubroute(item.section_url);
                                                                // Scroll to top when redirecting to a subroute
                                                                var routerContainer = document.querySelector(".router-container");
                                                                if (routerContainer) {
                                                                    routerContainer.scrollTo(0, -1000);
                                                                }
                                                            } else {
                                                                // Scroll to top when redirecting to a subroute
                                                                history.push("guide/".concat(item.section_url), {
                                                                    sectionData: item
                                                                });
                                                                var routerContainer1 = document.querySelector(".router-container");
                                                                if (routerContainer1) {
                                                                    routerContainer1.scrollTo(0, -1000);
                                                                }
                                                            }
                                                        },
                                                        children: /*#__PURE__*/ _jsxs("div", {
                                                            className: "section-text",
                                                            children: [
                                                                /*#__PURE__*/ _jsx("span", {
                                                                    className: "section-title",
                                                                    children: item.section_title
                                                                }),
                                                                /*#__PURE__*/ _jsx("span", {
                                                                    className: "section-subtitle",
                                                                    children: item.section_subtitle
                                                                })
                                                            ]
                                                        })
                                                    }, item.section_title);
                                                })
                                            ]
                                        }, data.primary.category_title);
                                    })
                                })
                            ]
                        })
                    ]
                });
            }
        }
    ]);
    return GuidePage;
}(PureComponent);
var mapStateToProps = function(param) {
    var i18n = param.i18n, history = param.history, authentication = param.authentication;
    return {
        i18n: i18n,
        authentication: authentication
    };
};
export default withRouter(withSnackbar(connect(mapStateToProps, {
    editBillingDetails: editBillingDetails,
    getFullUserDetails: getFullUserDetails,
    closeModal: closeModal
})(GuidePage)));
